import React from 'react';
import { Link } from 'react-router-dom';

const SocialMedia = () => {
  return (
    <div>
      <h2 className='mt-3 text-lg font-semibold tracking-wide text-gray-600'>Find Us On</h2>
      <button className='mt-2 w-full bg-slate-200 rounded-md py-1 font-medium text-gray-600'><a href="https://www.facebook.com/" target="_blank">Facebook</a></button>
      <button className='mt-2 w-full bg-slate-200 rounded-md py-1 font-medium text-gray-600'><a href="https://www.youtube.com/" target="_blank">Youtube</a></button>
      <button className='mt-2 w-full bg-slate-200 rounded-md py-1 font-medium text-gray-600'><a href="https://www.twitter.com/" target="_blank">Twitter</a></button>
      <button className='mt-2 w-full bg-slate-200 rounded-md py-1 font-medium text-gray-600'><a href="https://www.whatsapp.com/" target="_blank">WhatsApp</a></button>
      <button className='mt-2 w-full bg-slate-200 rounded-md py-1 font-medium text-gray-600'><a href="https://www.discord.com/" target="_blank">Discord</a></button>
      <button className='mt-2 w-full bg-slate-200 rounded-md py-1 font-medium text-gray-600'><Link to={'/privacypolicy'}>Privacy Policy</Link></button>
      <button className='mt-2 w-full bg-slate-200 rounded-md py-1 font-medium text-gray-600'><Link to={'/termscondition'}>Terms & Condition</Link></button>
    </div>
  );
};

export default SocialMedia;